/* global window */
'use strict';

module.exports = require('./ponyfill')(global || window || this);



/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-devtools-instrument/~/symbol-observable/index.js
 ** module id = 786
 ** module chunks = 0
 **/